import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import airflowApi from './airflowSlice';
import { errorMessages } from 'helpers/data/toastMessages';
import { throwErrorToast } from 'helpers/functions/toasts';

interface ApiErrorPayload {
    status?: number;
    originalStatus?: number;
    data?: {
        detail?: string;
        Title?: string;
    };
}

interface ApiMeta {
    arg: {
        endpointName: string;
    };
}

export const airflowApiQueryErrorLogger: Middleware = () => next => action => {
    if (isRejectedWithValue(action) && action.type.startsWith(airflowApi.reducerPath)) {
        const payload = action.payload as ApiErrorPayload;
        const meta = action.meta as ApiMeta;

        const status = payload?.status || payload?.originalStatus;
        const details = payload?.data?.detail;
        const endpointName = meta?.arg?.endpointName;

        const errorMessage = (errorCode: number) => (details ? details : errorMessages[errorCode]);

        if (status !== 401 && status !== 403) {
            console.warn(`Type: ${action.type}`);
            console.warn(`We got a rejected action in API! (ERROR CODE ${status}) - ${endpointName}`);
            console.warn(payload);
        }

        switch (status) {
            case 400:
            case 409:
                throwErrorToast({
                    message: errorMessage(status),
                    action,
                    errorCode: status,
                });
                break;

            case 401:
            case 403:
                console.warn(`Auth Error: ${status} at ${endpointName}`);
                break;

            case 404:
                if (payload?.data?.Title) {
                    console.log(payload.data.Title);
                }
                throwErrorToast({
                    message: errorMessage(404),
                    action,
                    errorCode: 404,
                });
                break;

            default:
                console.error(`Internal API ERROR! (500) - ${endpointName}`);
                throwErrorToast({
                    message: errorMessage(500),
                    action,
                    errorCode: 500,
                });
                break;
        }
    }

    return next(action);
};
